import React, { JSX } from 'react';
import { Box, Button } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import * as Types from 'types/types';
import { JobInfo } from './ui/JobInfo';
import { Scrollable } from './Scrollable';
import { StyledMarkdown } from './StyledMarkdown';

export function JobCreatorResult(props: {
  job: Types.Job;
  isMobile: boolean;
  isProcessing: boolean;
  jobTitle: string;
  company: string;
  jobDescription: string;
  onSave: () => void;
}): JSX.Element {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        minHeight: 0,
        maxHeight: 'min-content',
        position: 'relative',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexGrow: 1,
          gap: 1,
          height: '100%',
          width: '100%',
          minHeight: 0,
          maxHeight: 'min-content',
          '& > *:not(.Scrollable)': { flexShrink: 0 },
          position: 'relative',
        }}
      >
        <Scrollable sx={{ display: 'flex', flexGrow: 1, position: 'relative', maxHeight: '30rem' }}>
          <JobInfo job={props.job} />
        </Scrollable>
        <Scrollable sx={{ display: 'flex', flexGrow: 1, position: 'relative', maxHeight: '30rem' }}>
          <StyledMarkdown content={props.job.description} />
        </Scrollable>
      </Box>
      <Box sx={{ display: 'flex', gap: 2, alignItems: 'flex-end' }}>
        <Button
          variant="contained"
          onClick={props.onSave}
          disabled={
            !props.jobTitle || !props.company || !props.jobDescription || props.isProcessing
          }
          fullWidth={props.isMobile}
          size="large"
          startIcon={<CheckCircle />}
        >
          Save Job
        </Button>
      </Box>
    </Box>
  );
}
